import React, { useEffect, useState } from "react";
import { Grid, Button, Collapse, Card, CardContent, IconButton, Chip } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { LoadingButton } from '@mui/lab';
import LoadingWithText from "../../tools/LoadingWithText";
import PlanningMissionService from "../../../services/PlanningMissionService";
import Box from '@mui/material/Box';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import TableViewIcon from '@mui/icons-material/TableView';
import UserService from "../../../services/UserService";
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import Typography from '@mui/material/Typography';
import { Paper, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress } from '@mui/material';
import { DownloadOutlined, CheckCircle, Error, Info, Warning } from "@mui/icons-material";
import { 
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination
} from '@material-ui/core';
import LocalisationMisService from "../../../services/LocalisationMisService";

const useStyles = makeStyles({
    tableHeader: {
        backgroundColor: '#1a237e',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '0.85rem',
        padding: '12px 8px'
    },
    tableRow: {
        '&:hover': {
            backgroundColor: '#e3f2fd',
            transition: 'background-color 0.2s ease'
        },
        '&:nth-of-type(odd)': {
            backgroundColor: '#fafafa',
        },
    },
    tableCell: {
        borderRight: '1px solid #e0e0e0',
        padding: '10px 8px',
        fontSize: '0.8rem'
    },
    pagination: {
        borderTop: '1px solid #e0e0e0',
        backgroundColor: '#f5f5f5'
    },
    filterCard: {
        marginBottom: 24,
        padding: 20,
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        border: '1px solid #e0e0e0'
    },
    badge: {
        position: 'absolute',
        top: -8,
        right: -8,
        backgroundColor: '#f44336',
        color: 'white',
        borderRadius: '50%',
        width: 20,
        height: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.7rem',
        fontWeight: 'bold'
    },
    dialogSuccess: {
        '& .MuiDialogTitle-root': {
            backgroundColor: '#4caf50',
            color: 'white'
        }
    },
    dialogError: {
        '& .MuiDialogTitle-root': {
            backgroundColor: '#f44336',
            color: 'white'
        }
    },
    dialogWarning: {
        '& .MuiDialogTitle-root': {
            backgroundColor: '#ff9800',
            color: 'white'
        }
    },
    dialogInfo: {
        '& .MuiDialogTitle-root': {
            backgroundColor: '#2196f3',
            color: 'white'
        }
    },
    loadingAutocomplete: {
        display: 'flex',
        alignItems: 'center',
        '& .MuiAutocomplete-endAdornment': {
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        }
    }
});

function SuiviMission(props) {
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [filter, setFilter] = useState({
        date_debut: '',
        date_fin: '',
        direction: '',  
        directiondest: [],     
        service: '',
        reference: '',
        region: '',
        district: '',
        commune: ''
    });
    
    const [filtersExpanded, setFiltersExpanded] = useState(true);
    
    // État pour le dialogue
    const [dialog, setDialog] = useState({
        open: false,
        type: 'info',
        title: '',
        message: '',
        onConfirm: null
    });
    
    const [valdir, setValdir] = useState([]);
    const [direction, setDirection] = useState([]);
    const [allDirections, setAllDirections] = useState([]); 
    const [showTable, setShowTable] = useState(false);
    const [datatable, setDatatable] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [selectedService, setSelectedService] = useState(null);
    const [selectedDirection, setSelectedDirection] = useState(null);
    const [isloading, setIsloading] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false); 
    const [userDirectionId, setUserDirectionId] = useState(null); 
    
    // Liste complète des régions depuis l'API
    const [allRegions, setAllRegions] = useState([]);
    const [filteredRegions, setFilteredRegions] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [communes, setCommunes] = useState([]);
    
    // États pour les valeurs sélectionnées dans les autocomplete
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedCommune, setSelectedCommune] = useState(null);
    
    // États pour les loadings
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [loadingCommunes, setLoadingCommunes] = useState(false);
    
    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    
    const classes = useStyles();

    // Fonction pour afficher un dialogue
    const showDialog = (type, title, message, onConfirm = null) => {
        setDialog({
            open: true,
            type,
            title,
            message,
            onConfirm
        });
    };

    // Fonction pour fermer le dialogue
    const handleCloseDialog = () => {
        if (dialog.onConfirm) {
            dialog.onConfirm();
        }
        setDialog({ ...dialog, open: false });
    };

    // Récupérer l'icône en fonction du type
    const getDialogIcon = (type) => {
        switch(type) {
            case 'success':
                return <CheckCircle style={{ fontSize: 40, color: '#4caf50' }} />;
            case 'error':
                return <Error style={{ fontSize: 40, color: '#f44336' }} />;
            case 'warning':
                return <Warning style={{ fontSize: 40, color: '#ff9800' }} />;
            default:
                return <Info style={{ fontSize: 40, color: '#2196f3' }} />;
        }
    };

    // Récupérer la classe CSS en fonction du type
    const getDialogClass = (type) => {
        switch(type) {
            case 'success': return classes.dialogSuccess;
            case 'error': return classes.dialogError;
            case 'warning': return classes.dialogWarning;
            default: return classes.dialogInfo;
        }
    };

    // Gestionnaires de pagination
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getActiveFiltersCount = () => {
        let count = 0;
        if (filter.reference) count++;
        if (filter.date_debut && filter.date_fin) count++;
        if (filter.direction) count++;
        if (filter.service) count++;
        if (filter.directiondest && filter.directiondest.length > 0) count++;
        if (filter.region) count++;
        if (filter.district) count++;
        if (filter.commune) count++;
        return count;
    };

    const removeFilter = (filterName) => {
        switch(filterName) {
            case 'reference':
                setFilter(prev => ({ ...prev, reference: '' }));
                break;
            case 'dates':
                setFilter(prev => ({ ...prev, date_debut: '', date_fin: '' }));
                break;
            case 'direction':
                if (!isAdmin) {
                    showDialog('warning', 'Action non autorisée', 'Vous ne pouvez pas supprimer ce filtre car il est lié à votre direction.');
                    return;
                }
                setFilter(prev => ({ ...prev, direction: '' }));
                setSelectedDirection(null);
                break;
            case 'service':
                setFilter(prev => ({ ...prev, service: '' }));
                setSelectedService(null);
                break;
            case 'directiondest':
                setFilter(prev => ({ ...prev, directiondest: [] }));
                setValdir([]);
                break;
            case 'region':
                setFilter(prev => ({ ...prev, region: '', district: '', commune: '' }));
                setSelectedRegion(null);
                setSelectedDistrict(null);
                setSelectedCommune(null);
                setDistricts([]);
                setCommunes([]);
                break;
            case 'district':
                setFilter(prev => ({ ...prev, district: '', commune: '' }));
                setSelectedDistrict(null);
                setSelectedCommune(null);
                setCommunes([]);
                break;
            case 'commune':
                setFilter(prev => ({ ...prev, commune: '' }));
                setSelectedCommune(null);
                break;
            default:
                break;
        }
        if (showTable) {
            handleFilter();
        }
    };

    function handleChange(event) {
        const { name, value } = event.target;
        setFilter(prev => ({ ...prev, [name]: value }));
    }

    function handleChangeService(event, value) {
        setSelectedService(value);
        setFilter(prev => ({ ...prev, service: value?.service_id || '' }));
    }

    function handleChangeDirectionDestination(event, value) {
        setValdir(value);
        const ids = value.map(item => item.direction_id);
        setFilter(prev => ({ ...prev, directiondest: ids }));
    }

    function handleChangeDirectionMissionnaire(event, value) {
        if (!isAdmin && value && value.direction_id !== userDirectionId) {
            showDialog('warning', 'Action non autorisée', 'Vous ne pouvez sélectionner que votre propre direction.');
            return;
        }
        
        setSelectedDirection(value);
        setFilter(prev => ({ ...prev, direction: value?.direction_id || '' }));

        if (value?.direction_id) {
            PlanningMissionService.getServiceappui(value.direction_id).then((result) => {
                if (result && result.data) {
                    setServiceList(result.data);
                }
            }).catch((error) => {
                console.error('Error fetching services:', error);
                showDialog('error', 'Erreur', 'Impossible de charger les services');
            });
        } else {
            setServiceList([]);
        }
    }

    const extractUniqueRegions = (data) => {
        const uniqueRegions = new Map();
        data.forEach(item => {
            let regionObj = null;
            if (item.region && typeof item.region === 'object') {
                regionObj = item.region;
            } else if (item.region && typeof item.region === 'string') {
                try {
                    regionObj = JSON.parse(item.region);
                } catch (e) {}
            }
            
            if (regionObj && regionObj.id_region && !uniqueRegions.has(regionObj.id_region)) {
                uniqueRegions.set(regionObj.id_region, {
                    id: regionObj.id_region,
                    nom: regionObj.nom_region
                });
            }
        });
        return Array.from(uniqueRegions.values());
    };

    const extractUniqueDistricts = (data, selectedRegion) => {
        if (!selectedRegion) return [];
        
        const uniqueDistricts = new Map();
        data.forEach(item => {
            let itemRegion = null;
            if (item.region && typeof item.region === 'object') {
                itemRegion = item.region;
            } else if (item.region && typeof item.region === 'string') {
                try {
                    itemRegion = JSON.parse(item.region);
                } catch (e) {}
            }
            
            if (itemRegion && itemRegion.id_region === selectedRegion) {
                let districtsArray = [];
                if (item.district && typeof item.district === 'string') {
                    try {
                        districtsArray = JSON.parse(item.district);
                    } catch (e) {}
                } else if (Array.isArray(item.district)) {
                    districtsArray = item.district;
                }
                
                districtsArray.forEach(district => {
                    if (!uniqueDistricts.has(district.id_district)) {
                        uniqueDistricts.set(district.id_district, {
                            id: district.id_district,
                            nom: district.nom_district
                        });
                    }
                });
            }
        });
        return Array.from(uniqueDistricts.values());
    };

    const extractUniqueCommunes = (data, selectedDistrict) => {
        if (!selectedDistrict) return [];
        
        const uniqueCommunes = new Map();
        data.forEach(item => {
            let communesArray = [];
            if (item.commune && typeof item.commune === 'string') {
                try {
                    communesArray = JSON.parse(item.commune);
                } catch (e) {}
            } else if (Array.isArray(item.commune)) {
                communesArray = item.commune;
            }
            
            communesArray.forEach(commune => {
                if (commune.id_commune === selectedDistrict || 
                    (commune.id_district && commune.id_district === selectedDistrict)) {
                    if (!uniqueCommunes.has(commune.id_commune)) {
                        uniqueCommunes.set(commune.id_commune, {
                            id: commune.id_commune,
                            nom: commune.nom_commune
                        });
                    }
                }
            });
        });
        return Array.from(uniqueCommunes.values());
    };

    // Filtrer les régions en fonction des données du tableau
    const filterRegionsByData = (data) => {
        if (data && data.length > 0) {
            const uniqueRegions = extractUniqueRegions(data);
            setFilteredRegions(uniqueRegions);
        } else {
            setFilteredRegions(allRegions);
        }
    };

    useEffect(() => {
        if (datatable && datatable.length > 0) {
            filterRegionsByData(datatable);
            
            if (filter.region) {
                const uniqueDistricts = extractUniqueDistricts(datatable, filter.region);
                setDistricts(uniqueDistricts);
            } else {
                setDistricts([]);
            }
        } else {
            setFilteredRegions(allRegions);
            setDistricts([]);
            setCommunes([]);
        }
    }, [datatable, filter.region, allRegions]);

    useEffect(() => {
        if (datatable && datatable.length > 0 && filter.district) {
            const uniqueCommunes = extractUniqueCommunes(datatable, filter.district);
            setCommunes(uniqueCommunes);
        } else if (!filter.district) {
            setCommunes([]);
        }
    }, [datatable, filter.district]);

    const handleExportExcel = async () => {
        setIsloading(true);
        setOpenLoadingSimpleBackdrop(true);
        
        try {
            const exportFilter = buildFilterObject();
            exportFilter.export = true;
            
            const result = await PlanningMissionService.suivimission(exportFilter);
            
            if (result && result.data && result.data.length > 0) {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Suivi Missions');

                worksheet.columns = [
                    { header: 'Référence', key: 'reference', width: 20 },
                    { header: 'Missionnaire', key: 'nom', width: 30 },
                    { header: 'Matricule', key: 'registration_number', width: 15 },
                    { header: 'Fonction', key: 'function_name', width: 25 },
                    { header: 'Objet de la mission', key: 'mission_title', width: 35 },
                    { header: 'Direction', key: 'dir', width: 25 },
                    { header: 'Région', key: 'region', width: 20 },
                    { header: 'District', key: 'district', width: 20 },
                    { header: 'Commune', key: 'commune', width: 20 },
                    { header: 'Date de départ', key: 'date_debut', width: 15 },
                    { header: 'Date de retour', key: 'date_fin', width: 15 },
                    { header: 'Statut', key: 'statefinal', width: 15 },
                ];

                const headerRow = worksheet.getRow(1);
                headerRow.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: '1a237e' },
                    };
                    cell.font = { bold: true, color: { argb: 'FFFFFF' } };
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                });

                result.data.forEach((row) => {
                    let regionNom = '', districtNom = '', communeNom = '';

                    if (row.region && typeof row.region === 'object') {
                        regionNom = row.region.nom_region;
                    } else if (row.region && typeof row.region === 'string') {
                        try {
                            const regionObj = JSON.parse(row.region);
                            regionNom = regionObj.nom_region;
                        } catch (e) {}
                    }

                    if (row.district) {
                        try {
                            const districtArray = typeof row.district === 'string' ? JSON.parse(row.district) : row.district;
                            if (districtArray && districtArray.length > 0) {
                                districtNom = districtArray.map(d => d.nom_district).join(', ');
                            }
                        } catch (e) {}
                    }

                    if (row.commune) {
                        try {
                            const communeArray = typeof row.commune === 'string' ? JSON.parse(row.commune) : row.commune;
                            if (communeArray && communeArray.length > 0) {
                                communeNom = communeArray.map(c => c.nom_commune).join(', ');
                            }
                        } catch (e) {}
                    }

                    worksheet.addRow({
                        reference: row.reference,
                        nom: row.nom,
                        registration_number: row.registration_number,
                        function_name: row.function_name,
                        mission_title: row.mission_title,
                        dir: row.dir,
                        region: regionNom,
                        district: districtNom,
                        commune: communeNom,
                        date_debut: row.debut,
                        date_fin: row.fin,
                        statefinal: row.statefinal,
                    });
                });

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, `suivi_missions_${new Date().toISOString().split('T')[0]}.xlsx`);
                
                showDialog('success', 'Export réussi', `${result.data.length} mission(s) exportée(s) avec succès !`);
            } else {
                showDialog('warning', 'Aucune donnée', 'Aucune mission à exporter pour les critères sélectionnés.');
            }
        } catch (error) {
            console.error('Export error:', error);
            showDialog('error', 'Erreur d\'export', "Une erreur s'est produite lors de l'export Excel. Veuillez réessayer.");
        } finally {
            setIsloading(false);
            setOpenLoadingSimpleBackdrop(false);
        }
    };

    const buildFilterObject = () => {
        return {
            date_debut: filter.date_debut,
            date_fin: filter.date_fin,
            direction: filter.direction,          
            directiondest: filter.directiondest,   
            service: filter.service,
            reference: filter.reference,
            region: filter.region,
            district: filter.district,
            commune: filter.commune
        };
    };

    function handleFilter() {
        if (!filter.reference) {
            if (!filter.date_debut || !filter.date_fin) {
                showDialog('warning', 'Champs manquants', 'Veuillez indiquer les dates ou une référence de mission.');
                return;
            }
            if (new Date(filter.date_debut) > new Date(filter.date_fin)) {
                showDialog('warning', 'Dates invalides', 'La date de début doit précéder la date de fin.');
                return;
            }
        } else {
            if (filter.date_debut && filter.date_fin && new Date(filter.date_debut) > new Date(filter.date_fin)) {
                showDialog('warning', 'Dates invalides', 'La date de début doit précéder la date de fin.');
                return;
            }
        }
        
        setPage(0);
        fetchData();
    }

    const fetchData = async () => {
        setIsloading(true);
        setOpenLoadingSimpleBackdrop(true);
        
        const requestData = buildFilterObject();
        console.log("requestData", requestData);
        
        try {
            const result = await PlanningMissionService.suivimission(requestData);
            
            if (result && result.status === 'success') {
                setShowTable(true);
                setDatatable(result.data || []);
                
                if (result.data.length === 0) {
                    showDialog('info', 'Aucun résultat', 'Aucune mission trouvée pour les critères sélectionnés.');
                } else {
                    showDialog('success', 'Recherche effectuée', `${result.data.length} mission(s) trouvée(s).`);
                }
            } else {
                setShowTable(false);
                setDatatable([]);
                showDialog('info', 'Aucun résultat', 'Aucune donnée disponible pour les critères sélectionnés.');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setShowTable(false);
            showDialog('error', 'Erreur', 'Une erreur est survenue lors de la récupération des données. Veuillez réessayer.');
        } finally {
            setIsloading(false);
            setOpenLoadingSimpleBackdrop(false);
        }
    };

    function handlereinitiale() {
        const newFilter = {
            date_debut: '',
            date_fin: '',
            direction: isAdmin ? '' : userDirectionId,
            directiondest: [],
            service: '',
            reference: '',
            region: '',
            district: '',
            commune: ''
        };
        
        setFilter(newFilter);
        setValdir([]);
        setSelectedService(null);
        setSelectedRegion(null);
        setSelectedDistrict(null);
        setSelectedCommune(null);
        setDistricts([]);
        setCommunes([]);
        setFilteredRegions(allRegions);
        
        if (!isAdmin && userDirectionId) {
            const userDir = allDirections.find(d => parseInt(d.direction_id, 10) === parseInt(userDirectionId, 10));
            setSelectedDirection(userDir || null);
            
            if (userDirectionId) {
                PlanningMissionService.getServiceappui(userDirectionId).then((result) => {
                    if (result && result.data) {
                        setServiceList(result.data);
                    }
                }).catch((error) => {
                    console.error('Error fetching services:', error);
                });
            }
        } else {
            setSelectedDirection(null);
            setServiceList([]);
        }
        
        setDatatable([]);
        setShowTable(false);
        setPage(0);
        
        showDialog('info', 'Filtres réinitialisés', 'Tous les filtres ont été réinitialisés avec succès.');
    }

    const handleChangeRegion = async (event, newValue) => {
        setSelectedRegion(newValue);
        const regionId = newValue?.id_region || '';
        
        // Mettre à jour le filtre
        setFilter(prev => ({ 
            ...prev, 
            region: regionId, 
            district: '', 
            commune: '' 
        }));
        
        // Réinitialiser les sélections dépendantes
        setSelectedDistrict(null);
        setSelectedCommune(null);
        setCommunes([]);
        
        // Charger les districts si une région est sélectionnée
        if (regionId) {
            setLoadingDistricts(true);
            try {
                // Si on a des données dans datatable, on extrait les districts
                if (datatable && datatable.length > 0) {
                    const uniqueDistricts = extractUniqueDistricts(datatable, regionId);
                    setDistricts(uniqueDistricts);
                } else {
                    // Sinon, on appelle l'API
                    const result = await LocalisationMisService.getDistrictByRegion(regionId);
                    if (result && result.data) {
                        setDistricts(result.data);
                    } else {
                        setDistricts([]);
                    }
                }
            } catch (error) {
                console.error('Error fetching districts:', error);
                setDistricts([]);
                showDialog('error', 'Erreur', 'Impossible de charger les districts');
            } finally {
                setLoadingDistricts(false);
            }
        } else {
            setDistricts([]);
        }
    };
    
    const handleChangeDistrict = async (event, newValue) => {
        setSelectedDistrict(newValue);
        const districtId = newValue?.id_district || '';
        
        // Mettre à jour le filtre
        setFilter(prev => ({ 
            ...prev, 
            district: districtId, 
            commune: '' 
        }));
        
        // Réinitialiser la commune sélectionnée
        setSelectedCommune(null);
        
        // Charger les communes si un district est sélectionné
        if (districtId) {
            setLoadingCommunes(true);
            try {
                if (datatable && datatable.length > 0) {
                    const uniqueCommunes = extractUniqueCommunes(datatable, districtId);
                    setCommunes(uniqueCommunes);
                } else {
                    const result = await LocalisationMisService.getCommune(districtId);
                    if (result && result.data) {
                        setCommunes(result.data);
                    } else {
                        setCommunes([]);
                    }
                }
            } catch (error) {
                console.error('Error fetching communes:', error);
                setCommunes([]);
                showDialog('error', 'Erreur', 'Impossible de charger les communes');
            } finally {
                setLoadingCommunes(false);
            }
        } else {
            setCommunes([]);
        }
    };
    
    const handleChangeCommune = (event, newValue) => {
        setSelectedCommune(newValue);
        const communeId = newValue?.id_commune || '';
        setFilter(prev => ({ ...prev, commune: communeId }));
    };

    const handletdr = (filename, event) => {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        const filenamepdf = filename + ".pdf";
        const destination = process.env.REACT_APP_API_URL_FILE;
        const fileUrl = `${destination.replace(/\/$/, '')}/${filenamepdf}`;

        try {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = filenamepdf;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            showDialog('success', 'Téléchargement', 'Le téléchargement du fichier a commencé.');
        } catch (error) {
            showDialog('error', 'Erreur', 'Impossible de télécharger le fichier TDR.');
        }
    };

    useEffect(() => {
        const userData = localStorage.getItem('USER');
        if (userData) {
            UserService.getUserSummaryByUserId(userData)
                .then((result) => {
                    if (result && result.data) {
                        const dirpers = result.data.direction_id;
                        setUserDirectionId(dirpers);
                        
                        PlanningMissionService.getDirection().then((directionResult) => {
                            if (directionResult && directionResult.data) {
                                setAllDirections(directionResult.data);
                                
                                if (parseInt(dirpers, 10) === 1) {
                                    setIsAdmin(true);
                                    setDirection(directionResult.data);
                                    setSelectedDirection(null);
                                    setFilter((prev) => ({
                                        ...prev,
                                        direction: '',
                                    }));
                                } else {
                                    setIsAdmin(false);
                                    const userDirection = directionResult.data.filter(
                                        ts => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10)
                                    );
                                    setDirection(userDirection);
                                    
                                    if (userDirection.length > 0) {
                                        setSelectedDirection(userDirection[0]);
                                        setFilter((prev) => ({
                                            ...prev,
                                            direction: dirpers,
                                        }));
                                        
                                        PlanningMissionService.getServiceappui(dirpers).then((serviceResult) => {
                                            if (serviceResult && serviceResult.data) {
                                                setServiceList(serviceResult.data);
                                            }
                                        }).catch((error) => {
                                            console.error('Error fetching services:', error);
                                            showDialog('error', 'Erreur', 'Impossible de charger les services');
                                        });
                                    }
                                }
                            }
                        }).catch((error) => {
                            console.error('Error fetching direction data:', error);
                            showDialog('error', 'Erreur', 'Impossible de charger les directions.');
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error fetching user summary:', error);
                    showDialog('error', 'Erreur', 'Impossible de charger les informations utilisateur.');
                });
        }
        
        // Charger toutes les régions depuis l'API
        LocalisationMisService.getRegions().then((result) => {
            if (result && result.data) {
                setAllRegions(result.data);
                setFilteredRegions(result.data);
            }
        }).catch((error) => {
            console.error('Error fetching regions:', error);
        });
    }, []);

    return (
        <>
            <LoadingWithText openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
            
            <Dialog
                open={dialog.open}
                onClose={handleCloseDialog}
                className={getDialogClass(dialog.type)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {getDialogIcon(dialog.type)}
                    {dialog.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ fontSize: '1rem', marginTop: '16px' }}>
                        {dialog.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary" variant="contained" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Box style={{ padding: '24px', backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Box>
                        <Typography variant="h4" style={{ fontWeight: 'bold', color: '#1a237e' }}>
                            Suivi des Missions
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Gérez et suivez l'ensemble des missions
                            {!isAdmin && (
                                <span style={{ display: 'block', color: '#ff9800', fontSize: '0.8rem' }}>
                                    ⚠️ Vous êtes limité à la visualisation de votre direction uniquement
                                </span>
                            )}
                        </Typography>
                    </Box>
                    <Box display="flex" gap={2}>
                        <Button
                            variant="outlined"
                            onClick={() => setFiltersExpanded(!filtersExpanded)}
                            startIcon={filtersExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            style={{ borderRadius: '20px', textTransform: 'none', position: 'relative' }}
                        >
                            {filtersExpanded ? "Masquer les filtres" : "Afficher les filtres"}
                            {getActiveFiltersCount() > 0 && !filtersExpanded && (
                                <Box className={classes.badge}>
                                    {getActiveFiltersCount()}
                                </Box>
                            )}
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handlereinitiale}
                            startIcon={<RestartAltIcon />}
                            style={{ borderRadius: '20px', textTransform: 'none' }}
                        >
                            Réinitialiser
                        </Button>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: '#4caf50', color: 'white', borderRadius: '20px', textTransform: 'none' }}
                            onClick={handleExportExcel}
                            startIcon={<TableViewIcon />}
                        >
                            Export Excel
                        </Button>
                    </Box>
                </Box>

                {getActiveFiltersCount() > 0 && (
                    <Box mb={2}>
                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 500 }}>
                            Filtres actifs :
                        </Typography>
                        <Box mt={1} display="flex" flexWrap="wrap">
                            {filter.reference && (
                                <Chip
                                    label={`Référence: ${filter.reference}`}
                                    onDelete={() => removeFilter('reference')}
                                    size="small"
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                />
                            )}
                            {filter.date_debut && filter.date_fin && (
                                <Chip
                                    label={`Période: ${filter.date_debut} → ${filter.date_fin}`}
                                    onDelete={() => removeFilter('dates')}
                                    size="small"
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                />
                            )}
                            {filter.direction && selectedDirection && (
                                <Chip
                                    label={`Direction missionnaire: ${selectedDirection.name}`}
                                    onDelete={() => removeFilter('direction')}
                                    size="small"
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                    disabled={!isAdmin}
                                />
                            )}
                            {filter.service && selectedService && (
                                <Chip
                                    label={`Service: ${selectedService.name}`}
                                    onDelete={() => removeFilter('service')}
                                    size="small"
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                />
                            )}
                            {filter.directiondest && filter.directiondest.length > 0 && (
                                <Chip
                                    label={`${filter.directiondest.length} direction(s) destination`}
                                    onDelete={() => removeFilter('directiondest')}
                                    size="small"
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                />
                            )}
                            {filter.region && selectedRegion && (
                                <Chip
                                    label={`Région: ${selectedRegion.nom_region}`}
                                    onDelete={() => removeFilter('region')}
                                    size="small"
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                />
                            )}
                            {filter.district && selectedDistrict && (
                                <Chip
                                    label={`District: ${selectedDistrict.nom_district}`}
                                    onDelete={() => removeFilter('district')}
                                    size="small"
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                />
                            )}
                            {filter.commune && selectedCommune && (
                                <Chip
                                    label={`Commune: ${selectedCommune.nom_commune}`}
                                    onDelete={() => removeFilter('commune')}
                                    size="small"
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                />
                            )}
                        </Box>
                    </Box>
                )}

                <Collapse in={filtersExpanded}>
                    <Card className={classes.filterCard}>
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        label="Référence mission"
                                        size="small"
                                        variant="outlined"
                                        value={filter.reference}
                                        name="reference"
                                        onChange={handleChange}
                                        placeholder="Ex: MI-2025-07-4689"
                                        helperText="Recherche par référence - Les dates deviennent optionnelles"
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        label="Date départ"
                                        size="small"
                                        variant="outlined"
                                        type="date"
                                        value={filter.date_debut}
                                        name="date_debut"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        label="Date retour"
                                        size="small"
                                        variant="outlined"
                                        type="date"
                                        value={filter.date_fin}
                                        name="date_fin"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Autocomplete
                                        onChange={handleChangeDirectionMissionnaire}
                                        options={direction}
                                        value={selectedDirection}
                                        getOptionLabel={(option) => `${option.name} (${option.code})`}
                                        disabled={!isAdmin}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Direction missionnaire"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                helperText={!isAdmin ? "Direction verrouillée - vous ne pouvez voir que votre direction" : ""}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Autocomplete
                                        onChange={handleChangeService}
                                        options={serviceList}
                                        value={selectedService}
                                        getOptionLabel={(option) => `${option.name} (${option.code})`}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Service missionnaire"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Autocomplete
                                        onChange={handleChangeDirectionDestination}
                                        multiple
                                        value={valdir}
                                        options={direction}
                                        getOptionLabel={(option) => `${option.name} (${option.code})`}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Direction(s) destination"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Autocomplete
                                        onChange={handleChangeRegion}
                                        options={filteredRegions}
                                        value={selectedRegion}
                                        getOptionLabel={(option) => option.nom_region || ''}
                                        isOptionEqualToValue={(option, value) => option.id_region === value?.id_region}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Région"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Autocomplete
                                        onChange={handleChangeDistrict}
                                        options={districts}
                                        value={selectedDistrict}
                                        getOptionLabel={(option) => option.nom_district || ''}
                                        isOptionEqualToValue={(option, value) => option.id_district === value?.id_district}
                                        disabled={!filter.region || loadingDistricts}
                                        loading={loadingDistricts}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="District"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                disabled={!filter.region}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loadingDistricts && <CircularProgress color="inherit" size={20} />}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Autocomplete
                                        onChange={handleChangeCommune}
                                        options={communes}
                                        value={selectedCommune}
                                        getOptionLabel={(option) => option.nom_commune || ''}
                                        isOptionEqualToValue={(option, value) => option.id_commune === value?.id_commune}
                                        disabled={!filter.district || loadingCommunes}
                                        loading={loadingCommunes}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Commune"
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                disabled={!filter.district}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loadingCommunes && <CircularProgress color="inherit" size={20} />}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                        <LoadingButton
                                            variant="contained"
                                            onClick={handleFilter}
                                            loading={isloading}
                                            style={{
                                                fontWeight: 600,
                                                minWidth: 200,
                                                borderRadius: '25px',
                                                backgroundColor: '#1a237e',
                                                padding: '8px 32px'
                                            }}
                                            startIcon={<SearchIcon />}
                                        >
                                            Rechercher
                                        </LoadingButton>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Collapse>

                {showTable && (
                    <>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                                {datatable.length} mission(s) trouvée(s)
                            </Typography>
                        </Box>
                        
                        <Paper style={{ borderRadius: '12px', overflow: 'hidden' }}>
                            <TableContainer style={{ maxHeight: '70vh', overflowX: 'auto' }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHeader}>Référence</TableCell>
                                            <TableCell className={classes.tableHeader}>Missionnaire</TableCell>
                                            <TableCell className={classes.tableHeader}>Objet</TableCell>
                                            <TableCell className={classes.tableHeader}>Direction</TableCell>
                                            <TableCell className={classes.tableHeader}>Région</TableCell>
                                            <TableCell className={classes.tableHeader}>District</TableCell>
                                            <TableCell className={classes.tableHeader}>Commune</TableCell>
                                            <TableCell className={classes.tableHeader}>Date départ</TableCell>
                                            <TableCell className={classes.tableHeader}>Date retour</TableCell>
                                            <TableCell className={classes.tableHeader}>TDR</TableCell>
                                            <TableCell className={classes.tableHeader}>Statut</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {datatable
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                            
                                            let regionNom = '', districtNom = '', communeNom = '';
                                            
                                            if (row.region && typeof row.region === 'object') {
                                                regionNom = row.region.nom_region;
                                            } else if (row.region && typeof row.region === 'string') {
                                                try {
                                                    const regionObj = JSON.parse(row.region);
                                                    regionNom = regionObj.nom_region;
                                                } catch (e) {}
                                            }
                                            
                                            if (row.district) {
                                                try {
                                                    const districtArray = typeof row.district === 'string' ? JSON.parse(row.district) : row.district;
                                                    if (districtArray && districtArray.length > 0) {
                                                        districtNom = districtArray.map(d => d.nom_district).join(', ');
                                                    }
                                                } catch (e) {}
                                            }
                                            
                                            if (row.commune) {
                                                try {
                                                    const communeArray = typeof row.commune === 'string' ? JSON.parse(row.commune) : row.commune;
                                                    if (communeArray && communeArray.length > 0) {
                                                        communeNom = communeArray.map(c => c.nom_commune).join(', ');
                                                    }
                                                } catch (e) {}
                                            }
                                            
                                            return (
                                                <TableRow key={`${row.reference}-${index}`} className={classes.tableRow}>
                                                    <TableCell className={classes.tableCell}>
                                                        <strong style={{ color: '#1a237e' }}>{row.reference}</strong>
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        <div><strong>{row.nom}</strong></div>
                                                        <small style={{ color: '#666' }}>{row.registration_number}</small>
                                                        <div><small>{row.function_name}</small></div>
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {row.mission_title?.length > 50 ? 
                                                            `${row.mission_title.substring(0, 50)}...` : 
                                                            row.mission_title}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        <div><strong>{row.dir}</strong></div>
                                                        <small>{row.lieuexact}</small>
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {regionNom || '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {districtNom || '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {communeNom || '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {row.debut || '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {row.fin || '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell} align="center">
                                                        {row.filenamepdf && (
                                                            <IconButton 
                                                                onClick={(event) => handletdr(row.filenamepdf, event)} 
                                                                size="small" 
                                                                title="Télécharger TDR"
                                                                style={{ backgroundColor: '#e3f2fd' }}
                                                            >
                                                                <DownloadOutlined style={{ color: "#1a237e" }} />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        <Box component="span" sx={{
                                                            padding: '4px 10px',
                                                            borderRadius: '20px',
                                                            display: 'inline-block',
                                                            fontWeight: 'bold',
                                                            fontSize: '0.7rem',
                                                            backgroundColor: 
                                                                row.statefinal === 'Validé' ? '#4caf50' : '#9e9e9e',
                                                            color: 'white'
                                                        }}>
                                                            {row.statefinal}
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                component="div"
                                count={datatable.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                className={classes.pagination}
                                labelRowsPerPage="Lignes par page:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
                            />
                        </Paper>
                    </>
                )}
            </Box>
        </>
    );
}

export default SuiviMission;